document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('[data-mublig-hero-v3]');
  if (!hero) return;

  if (hero.dataset.mubligHeroReady === 'true') return;
  hero.dataset.mubligHeroReady = 'true';

  const quantityInput = hero.querySelector('.mublig-hero-v3__quantity input[name="quantity"]');
  const minusButton = hero.querySelector('.mublig-hero-v3__quantity button[name="minus"]');
  const plusButton = hero.querySelector('.mublig-hero-v3__quantity button[name="plus"]');
  const productForm = hero.querySelector('form[action*="/cart/add"]');
  const cartButton = hero.querySelector('.mublig-hero-v3__cart-button');

  const shippingPriceEl = hero.querySelector('[data-mublig-hero-shipping-price]');
  const progressTitleEl = hero.querySelector('[data-mublig-hero-progress-title]');
  const progressBarEl = hero.querySelector('[data-mublig-hero-progress-bar]');
  const progressMissingEl = hero.querySelector('[data-mublig-hero-progress-missing]');

  const gallery = hero.querySelector('[data-mublig-custom-gallery]');
  const mainImageBox = hero.querySelector('.mublig-hero-v3__main-image');
  const thumbsBox = hero.querySelector('.mublig-hero-v3__thumbs');
  const buybox = hero.querySelector('.mublig-hero-v3__buybox');
  const mediaColumn = hero.querySelector('.mublig-hero-v3__media');
  const colorsBlock = hero.querySelector('.mublig-hero-v3__colors');

  const shopRoot = window.Shopify?.routes?.root || '/';

  let shippingUpdateId = 0;
  let syncFrame = null;
  let greenCartButtonClicked = false;

  const setImportant = (el, prop, value) => {
    if (!el) return;
    el.style.setProperty(prop, value, 'important');
  };

  const removeInlineSizing = () => {
    [mediaColumn, gallery, mainImageBox, thumbsBox].forEach((el) => {
      if (!el) return;
      el.style.removeProperty('height');
      el.style.removeProperty('min-height');
      el.style.removeProperty('max-height');
      el.style.removeProperty('flex-basis');
    });

    if (colorsBlock) {
      colorsBlock.style.removeProperty('margin-top');
    }
  };

  const syncLeftSideToBuybox = () => {
    if (!buybox || !mediaColumn || !gallery || !mainImageBox) return;

    if (window.matchMedia('(max-width: 1023px)').matches) {
      removeInlineSizing();
      return;
    }

    const buyboxHeight = Math.ceil(buybox.getBoundingClientRect().height);
    if (!buyboxHeight || buyboxHeight < 300) return;

    const colorsGap = 10;
    const colorsHeight = colorsBlock
      ? Math.ceil(colorsBlock.getBoundingClientRect().height)
      : 0;

    let galleryHeight = buyboxHeight - colorsHeight - colorsGap;

    galleryHeight = Math.max(330, galleryHeight);
    galleryHeight = Math.min(560, galleryHeight);

    setImportant(mediaColumn, 'height', `${buyboxHeight}px`);
    setImportant(mediaColumn, 'min-height', `${buyboxHeight}px`);

    setImportant(gallery, 'height', `${galleryHeight}px`);
    setImportant(gallery, 'min-height', `${galleryHeight}px`);
    setImportant(gallery, 'flex-basis', `${galleryHeight}px`);

    setImportant(mainImageBox, 'height', `${galleryHeight}px`);
    setImportant(mainImageBox, 'min-height', `${galleryHeight}px`);

    if (thumbsBox) {
      setImportant(thumbsBox, 'height', `${galleryHeight}px`);
      setImportant(thumbsBox, 'max-height', `${galleryHeight}px`);
    }

    if (colorsBlock) {
      setImportant(colorsBlock, 'margin-top', `${colorsGap}px`);
    }
  };

  const scheduleLeftSideSync = () => {
    if (syncFrame) window.cancelAnimationFrame(syncFrame);

    syncFrame = window.requestAnimationFrame(() => {
      syncLeftSideToBuybox();
    });
  };

  const formatMoney = (cents) => {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  };

  const getQuantity = () => {
    if (!quantityInput) return 1;
    const value = parseInt(quantityInput.value || '1', 10);
    return Number.isFinite(value) ? Math.max(1, value) : 1;
  };

  const setQuantity = (value) => {
    if (!quantityInput) return;
    quantityInput.value = Math.max(1, value);
    updateShipping();
  };

  const getCartTotal = async () => {
    try {
      const response = await fetch(`${shopRoot}cart.js`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });

      if (!response.ok) return Number(hero.dataset.pdpHeroCartCents || 0);

      const cart = await response.json();
      return Number(cart.total_price || 0);
    } catch (error) {
      return Number(hero.dataset.pdpHeroCartCents || 0);
    }
  };

  const getCart = async () => {
    const response = await fetch(`${shopRoot}cart.js`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Warenkorb konnte nicht geladen werden.');
    }

    return response.json();
  };

  const broadcastCartUpdate = (cart) => {
    const eventNames = [
      'cart:updated',
      'cart:refresh',
      'cart:change',
      'mublig:cart-updated'
    ];

    eventNames.forEach((eventName) => {
      document.dispatchEvent(new CustomEvent(eventName, {
        detail: { cart }
      }));
    });
  };

  const updateShipping = async () => {
    const currentUpdateId = ++shippingUpdateId;
    const group = hero.dataset.pdpHeroShippingGroup;

    if (!group) {
      if (shippingPriceEl) shippingPriceEl.textContent = 'im Warenkorb berechnet';
      if (progressTitleEl) progressTitleEl.textContent = 'Versandkosten werden im Warenkorb berechnet.';
      if (progressBarEl) progressBarEl.style.width = '0%';
      if (progressMissingEl) progressMissingEl.textContent = '';
      scheduleLeftSideSync();
      return;
    }

    const cartTotal = await getCartTotal();
    if (currentUpdateId !== shippingUpdateId) return;

    const productPrice = Number(hero.dataset.pdpHeroProductCents || 0);
    
    const normal = Number(hero.dataset.pdpHeroShippingNormalCents || 0);
    const reduced = Number(hero.dataset.pdpHeroShippingReducedCents || 0);
    const reducedThreshold = Number(hero.dataset.pdpHeroShippingReducedThresholdCents || 0);
    const freeThreshold = Number(hero.dataset.pdpHeroShippingFreeThresholdCents || 0);
    const quantity = getQuantity();

    /*
      Zwei getrennte Werte:

      1. currentCartTotal:
        Nur aktueller Warenkorb.
        Wird für die Progressbar genutzt.

      2. cartTotalAfterAdd:
        Aktueller Warenkorb + aktuelles Produkt * Menge.
        Wird für die angezeigten Versandkosten genutzt.
    */
    const currentCartTotal = cartTotal;
    const cartTotalAfterAdd = currentCartTotal + productPrice * quantity;

    /*
      Versandkosten-Zeile:
      Rechnet so, als würde der Kunde dieses Produkt jetzt hinzufügen.
    */
    let shippingPrice = normal;

    if (freeThreshold > 0 && cartTotalAfterAdd >= freeThreshold) {
      shippingPrice = 0;
    } else if (reducedThreshold > 0 && cartTotalAfterAdd >= reducedThreshold) {
      shippingPrice = reduced;
    }

    /*
      Progressbar:
      Rechnet ausschließlich nach aktuellem Warenkorb.
      Das Produkt wird hier NICHT dazugerechnet.
    */
    const missingFree = Math.max(0, freeThreshold - currentCartTotal);
    const progress = freeThreshold > 0
      ? Math.min(100, Math.round((currentCartTotal / freeThreshold) * 100))
      : 0;

    if (shippingPriceEl) {
      shippingPriceEl.textContent = shippingPrice === 0 ? 'kostenlos' : formatMoney(shippingPrice);
    }

    if (progressTitleEl) {
      if (currentCartTotal >= freeThreshold) {
        progressTitleEl.textContent = 'Dein Warenkorb erreicht kostenlosen Versand!';
      } else {
        progressTitleEl.textContent = `Noch ${formatMoney(missingFree)} bis zum kostenlosen Versand!`;
      }
    }

    if (progressBarEl) {
      progressBarEl.style.width = `${progress}%`;
    }

    if (progressMissingEl) {
      progressMissingEl.textContent = missingFree > 0 ? `${formatMoney(missingFree)} fehlen` : '';
    }

    scheduleLeftSideSync();
  };

  const addToCartAjax = async () => {
    if (!productForm) return;

    const originalButtonHTML = cartButton ? cartButton.innerHTML : '';
    const formData = new FormData(productForm);

    if (cartButton) {
      cartButton.disabled = true;
      cartButton.classList.add('is-loading');
      cartButton.setAttribute('aria-busy', 'true');
    }

    try {
      const addResponse = await fetch(`${shopRoot}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      });

      if (!addResponse.ok) {
        const errorData = await addResponse.json().catch(() => null);
        throw new Error(errorData?.description || 'Produkt konnte nicht hinzugefügt werden.');
      }

      const cart = await getCart();

      broadcastCartUpdate(cart);

      if (cartButton) {
        cartButton.classList.remove('is-loading');
        cartButton.classList.add('is-added');
        cartButton.innerHTML = 'Hinzugefügt';

        setTimeout(() => {
          cartButton.innerHTML = originalButtonHTML;
          cartButton.classList.remove('is-added');
        }, 1400);
      }

      updateShipping();
      scheduleLeftSideSync();
    } catch (error) {
      console.error(error);
      alert(error.message || 'Produkt konnte nicht hinzugefügt werden.');

      if (cartButton) {
        cartButton.innerHTML = originalButtonHTML;
      }
    } finally {
      if (cartButton) {
        cartButton.disabled = false;
        cartButton.classList.remove('is-loading');
        cartButton.removeAttribute('aria-busy');
      }

      greenCartButtonClicked = false;
    }
  };

  if (minusButton) {
    minusButton.addEventListener('click', () => {
      setQuantity(getQuantity() - 1);
    });
  }

  if (plusButton) {
    plusButton.addEventListener('click', () => {
      setQuantity(getQuantity() + 1);
    });
  }

  if (quantityInput) {
    quantityInput.addEventListener('input', updateShipping);
    quantityInput.addEventListener('change', updateShipping);
  }

  if (cartButton) {
    cartButton.addEventListener('click', () => {
      greenCartButtonClicked = true;
    });
  }

  if (productForm) {
    productForm.addEventListener('submit', (event) => {
      const submitter = event.submitter || null;
      const isGreenCartButton =
        submitter === cartButton ||
        greenCartButtonClicked ||
        submitter?.classList?.contains('mublig-hero-v3__cart-button');

      if (!isGreenCartButton) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      addToCartAjax();
    }, true);
  }

  if (gallery) {
    const mainImage = gallery.querySelector('[data-mublig-gallery-main]');
    const mainImageBox = hero.querySelector('.mublig-hero-v3__main-image');
    const thumbs = Array.from(gallery.querySelectorAll('[data-mublig-gallery-thumb]'));
    const prevButton = hero.querySelector('[data-mublig-gallery-prev]');
    const nextButton = hero.querySelector('[data-mublig-gallery-next]');

    let currentImageIndex = thumbs.findIndex((thumb) => thumb.classList.contains('is-active'));

    if (currentImageIndex < 0) {
      currentImageIndex = 0;
    }

    let lastSwipeTime = 0;

    const getThumbImageUrl = (thumb) => {
      return (
        thumb.dataset.fullImage ||
        thumb.querySelector('img')?.dataset.src ||
        thumb.querySelector('img')?.src ||
        ''
      );
    };

    const setActiveImage = (index) => {
      if (!mainImage || !thumbs.length) return;

      if (index < 0) {
        index = thumbs.length - 1;
      }

      if (index >= thumbs.length) {
        index = 0;
      }

      if (index === currentImageIndex) return;

      const thumb = thumbs[index];
      const imageUrl = getThumbImageUrl(thumb);
      const alt = thumb.dataset.alt || thumb.querySelector('img')?.alt || '';

      if (!imageUrl) return;

      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');

      mainImage.src = imageUrl;
      mainImage.alt = alt;

      thumbs.forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');

      currentImageIndex = index;

      thumb.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });

      if (typeof scheduleLeftSideSync === 'function') {
        scheduleLeftSideSync();
      }
    };

    const showNextImage = () => {
      setActiveImage(currentImageIndex + 1);
    };

    const showPreviousImage = () => {
      setActiveImage(currentImageIndex - 1);
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        setActiveImage(index);
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        showPreviousImage();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        showNextImage();
      });
    }

    let touchStartX = 0;
    let touchStartY = 0;

    if (mainImageBox) {
      mainImageBox.addEventListener(
        'touchstart',
        (event) => {
          if (!event.touches || !event.touches.length) return;

          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        },
        { passive: true }
      );

      mainImageBox.addEventListener(
        'touchend',
        (event) => {
          if (!event.changedTouches || !event.changedTouches.length) return;

          const now = Date.now();

          /*
            Schutz gegen doppeltes Auslösen.
            Manche Browser feuern Swipe-Events sehr schnell doppelt.
          */
          if (now - lastSwipeTime < 350) return;

          const touchEndX = event.changedTouches[0].clientX;
          const touchEndY = event.changedTouches[0].clientY;

          const diffX = touchEndX - touchStartX;
          const diffY = touchEndY - touchStartY;

          const absX = Math.abs(diffX);
          const absY = Math.abs(diffY);

          /*
            Nur horizontales Wischen.
            Vertikales Scrollen bleibt normal.
          */
          if (absX < 45 || absX < absY * 1.25) return;

          lastSwipeTime = now;

          if (diffX < 0) {
            showNextImage();
          } else {
            showPreviousImage();
          }
        },
        { passive: true }
      );
    }
  }

  window.addEventListener('resize', scheduleLeftSideSync);
  window.addEventListener('load', scheduleLeftSideSync);

  document.addEventListener('cart:updated', () => {
    updateShipping();
    scheduleLeftSideSync();
  });

  document.addEventListener('cart:refresh', () => {
    updateShipping();
    scheduleLeftSideSync();
  });

     if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(scheduleLeftSideSync);

      if (buybox) observer.observe(buybox);
      if (colorsBlock) observer.observe(colorsBlock);
      if (gallery) observer.observe(gallery);
    }

    const floatingWishlistButton = hero.querySelector('[data-mublig-floating-wishlist]');

    const getRealWishlistButton = () => {
      const selectors = [
        '.mublig-hero-v3__wishlist:not(.mublig-hero-v3__wishlist-float)',
        '.mublig-hero-v3__wishlist button',
        '.mublig-hero-v3__wishlist a',
        '[data-wishlist-button]:not([data-mublig-floating-wishlist])',
        '[data-wishlist-add]',
        '[data-add-to-wishlist]',
        '.wishlist-button:not(.mublig-hero-v3__wishlist-float)',
        'button[aria-label*="Wunschliste"]',
        'button[aria-label*="wishlist" i]',
        'a[aria-label*="Wunschliste"]',
        'a[aria-label*="wishlist" i]'
      ];

      for (const selector of selectors) {
        const target = hero.querySelector(selector);

        if (
          target &&
          target !== floatingWishlistButton &&
          typeof target.click === 'function'
        ) {
          return target;
        }
      }

      return null;
    };

    if (floatingWishlistButton) {
      floatingWishlistButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const realWishlistButton = getRealWishlistButton();

        floatingWishlistButton.classList.toggle('is-active');

        const isActive = floatingWishlistButton.classList.contains('is-active');
        floatingWishlistButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        if (realWishlistButton) {
          realWishlistButton.click();
        } else {
          console.warn('MUBLIG: Kein echter Wunschlisten-Button gefunden.');
        }
      });
    }

    updateShipping();

    setTimeout(scheduleLeftSideSync, 100);
    setTimeout(scheduleLeftSideSync, 500);
    setTimeout(scheduleLeftSideSync, 1200);
  });